import {
    FC,
    ReactElement,
    useEffect,
    useState,
} from 'react'
import classnames from 'classnames'

import { Icon, IconName } from '@/components'
import { IconButton } from '@/compositions/@buttons/IconButton/IconButton'
import { trans } from '@/helpers/trans'
import { Toast as ToastInterface, ToastType } from '@/types'

import './Toast.scss'

interface ToastProps {
    toast: ToastInterface
    className?: string
}

let timeoutInstance: NodeJS.Timeout

export const Toast: FC<ToastProps> = ({
    toast,
    className = '',
}): ReactElement => {
    const [isVisible, setIsVisible] = useState(true)

    let iconName: IconName = 'info-circle'

    if ([ToastType.fail, ToastType.warning].includes(toast.type)) {
        iconName = 'warning-triangle'
    }

    if (toast.type === ToastType.pass) {
        iconName = 'check-circle'
    }

    const handleOnClose = (): void => {
        setIsVisible(false)
    }

    useEffect((): () => void => {
        if (toast.shouldFadeOutAutomatically) {
            timeoutInstance = setTimeout(
                handleOnClose,
                toast.type === ToastType.updateApp ? 20000 : 4000,
            )
        }

        return () => {
            if (timeoutInstance) clearTimeout(timeoutInstance)
        }
    }, [])

    const toastClassNames = classnames('toast-paco', {
        'toast-paco--is-visible': isVisible,
    }, className)

    return (
        <div className={toastClassNames}>
            <div className={`toast-paco__icon-wrapper toast-paco__icon-wrapper--${toast.type}`}>
                <Icon name={iconName} className="toast-paco__icon" />
            </div>
            <div className="toast-paco__body">
                {toast.text}
            </div>
            <IconButton
                hideLabel
                icon="cross-close"
                text={trans('common.close')}
                onClick={handleOnClose}
                className="toast-paco__close-button"
                iconClassName="toast-paco__close-button-icon"
            />
        </div>
    )
}
